import { createAsyncThunk } from "@reduxjs/toolkit";
import obligationService from "../../Services/ObligationService";
import { ResponseMessageHandler } from "../../globals/components/notification";

export const getObligation = createAsyncThunk(
  "Obligation/getObligation",
  async (data, thunkAPI) => {
    try {
      let res = await obligationService.getObligationAPI({
        ...data,
        limit: data.pageSize,
        page: data.current,
        // orderBy :"updatedAt"
      });

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const createObligation = createAsyncThunk(
  "Obligation/createObligation",
  async ({ data, ObligationPagination }, thunkAPI) => {
    try {
      const res = await obligationService.createObligationAPI(data);
      thunkAPI.dispatch(getObligation(ObligationPagination));
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteObligation = createAsyncThunk(
  "Obligation/deleteObligation",
  async ({ data, ObligationPagination }, thunkAPI) => {
    try {
      const res = await obligationService.deleteObligationAPI(data);
      ResponseMessageHandler(res);
      thunkAPI.dispatch(getObligation(ObligationPagination));
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
